<template>
  <div v-if="article">
    <div class="top">
      <router-link class="link-back" :to="'/resources'">
        <div>
          &larr; Back to Resources
        </div>
      </router-link>
      <div>
        <bg-button
          v-if="userState.user.company.id === 2"
          style="margin-right: 10px;"
          variant="secondary"
          @click="$router.push(`/resources/${$route.params.id}/edit`)"
          text="Edit"
        ></bg-button>
        <bg-button
          v-if="userState.user.company.id === 2"
          style="margin-right: 10px;"
          variant="secondary"
          @click="deleteArticle()"
          text="Delete"
        ></bg-button>
        <bg-button
          v-if="userState.user.company.id === 2 && !article.published"
          variant="primary"
          @click="updatePublished"
          text="Publish"
        ></bg-button>
        <bg-button
          v-if="userState.user.company.id === 2 && article.published"
          variant="destructive"
          @click="updatePublished"
          text="Unpublish"
        ></bg-button>
      </div>
    </div>

    <div class="article">
      <div
        class="image"
        :style="{ 'background-image': `url(${article.image})` }"
      >
        <div class="tags">
          <div
            class="tag"
            v-for="tag in article.tags"
            :key="tag"
            @click="tagSearch(tag)"
          >
            <span>{{ tag }}</span>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content-header">
          <div class="title">
            <h1 v-bg-typography="'h1'">{{ article.title }}</h1>
          </div>
          <div class="right">
            <!-- <div class="actions">
              <div class="views">
                <p>{{ article.views }} views</p>
              </div>
              <div @click.stop="start" class="lottie-wrapper">
                <lottie
                  :options="defaultOptions"
                  :height="40"
                  :width="40"
                  v-on:animCreated="handleAnimation"
                  style="margin-right: 0;"
                />
              </div>
            </div> -->
            <div
              class="author"
              style="display: flex; align-items: center; gap: 10px; "
            >
              <p>{{ article.author }}</p>
              <img
                v-if="
                  article.author === 'Max van Kaathoven' ||
                    article.author === 'Braingineers admin'
                "
                src="@/assets/imgs/researchers/max.jpg"
                alt=""
              />
              <img
                v-else-if="article.author === 'Eltine van der Veer'"
                src="@/assets/imgs/researchers/eltine.jpg"
                alt=""
              />
              <img
                v-else-if="article.author === 'Sam Goos'"
                src="@/assets/imgs/researchers/sam.jpg"
                alt=""
              />
              <img
                v-else-if="article.author === 'Marion Veth'"
                src="@/assets/imgs/researchers/marion.jpg"
                alt=""
              />
              <img
                v-else-if="article.author === 'Jamie van der Heijde'"
                src="@/assets/imgs/researchers/jamie.jpg"
                alt=""
              />
              <img
                v-else-if="article.author === 'Danique Verweij'"
                src="@/assets/imgs/researchers/danique.jpg"
                alt=""
              />
            </div>
            <p style="text-align: end; margin-top: 10px;">{{ article.date }}</p>
          </div>
        </div>

        <div class="content-body">
          <p>
            <span v-html="article.body"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";
// import Lottie from "vue-lottie";
import * as animationData from "./favorite.json";
import BgButton from "@/components/bg-button";
import API from "@/api";
import { mapState } from "vuex";

export default {
  components: {
    // Lottie,
    BgButton,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      article: null,
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: false,
      },
      animationSpeed: 1,
      direction: 1,
    };
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
  },
  methods: {
    async deleteArticle() {
      let r = confirm("Are you sure?!");
      if (r == true) {
        const result = await API.resource.deleteResource(this.$route.params.id);
        console.log(result);
        this.$router.push("/resources");
      }
    },
    handleAnimation: function(anim) {
      this.anim = anim;
    },
    start() {
      if (this.direction === 1) {
        this.anim.play();
      } else {
        this.anim.stop();
      }
      this.direction = this.direction * -1;
    },
    async updatePublished() {
      const result = await API.resource.updateResource({
        id: this.article.id,
        published: !this.article.published,
      });
      this.article.published = result.published;
    },
    tagSearch(tag) {
      this.$router.push({ path: "/resources", query: { tag: tag } });
    },
  },
  async mounted() {
    const result = await API.resource.getResource(this.$route.params.id);
    this.article = {
      title: result.title,
      tags: result.tags,
      date: result.date,
      author: result.author,
      favorited: false,
      id: result.id,
      body: result.body,
      views: 0,
      image: result.image,
      published: result.published,
    };
  },
};
</script>

<style scoped lang="scss">
@import "./styles.scss";
</style>
